<label class="load-event-value label label-default" *ngIf="event.oldValue">
    {{ event.oldValue }}
</label>
<span class="load-event-empty-value" *ngIf="!event.oldValue" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.empty-value'}]">
</span>

<span class="load-event-values-separator">
    <i class="fa fa-arrow-right"></i>
</span>

<label class="load-event-value label label-default" *ngIf="event.newValue">
    {{ event.newValue }}
</label>
<span class="load-event-empty-value" *ngIf="!event.newValue" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.empty-value'}]">
</span>
